<template>
  <div class='app-container'>
    <icare-table
      ref='table'
      searchTip='请根据设备编号进行搜索'
      :title-config='titleConfig'
      :request-fun='requestFun'
      :table-pagination='true'
      :pagination-config='tableParams'
      methods-data='get_agency_user'
      params>
      <div>
        <!--        <span class="left-table">编号：</span>-->
        <!--        <el-input v-model="id" placeholder="请输入编号" style="width: 200px;" clearable></el-input>-->
        <!--        <span class="left-table">-->
        <!--          <el-button type="primary" icon="el-icon-search" @click="find">查找</el-button>-->
        <!--        </span>-->
        <span class='left-table'>
          <el-button type='success' icon='el-icon-circle-plus' @click='showAdd'>增加</el-button>
        </span>
      </div>
    </icare-table>

    <!-- 编辑 -->
    <el-dialog :title='editTip' :visible.sync='editVisible' width='23%' @closed='closeDialog'>
      <el-form label-width='80px' ref='form' :rules='rules' :model='form'>
        <el-form-item label='登录账户' v-if='!isEdit' prop='login_name'>
          <el-input t v-model='form.login_name' placeholder='请输入登录账户'></el-input>
        </el-form-item>
        <el-form-item label='登录密码' v-if='!isEdit' prop='password'>
          <el-input t v-model='form.password' placeholder='请输入登录密码'></el-input>
        </el-form-item>
        <el-form-item label='用户姓名' prop='name'>
          <el-input t v-model='form.name' placeholder='请输入用户姓名'></el-input>
        </el-form-item>
        <el-form-item label='手机号码' prop='phone'>
          <el-input t v-model='form.phone' placeholder='请输入手机号码'></el-input>
        </el-form-item>

        <el-form-item label='用户角色' prop='role_id'>
          <el-select v-model='form.role_id' placeholder='请选择'>
            <el-option
              v-for='item in role_options'
              :key='item.id'
              :label='item.role_name'
              :value='item.id'>
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot='footer' class='dialog-footer'>
        <el-button icon='el-icon-circle-close' @click='closeDialog'>取 消</el-button>
        <el-button type='primary' icon='el-icon-circle-plus-outline' @click='save'>确 定</el-button>
      </div>
    </el-dialog>


    <el-dialog title='设置密码' :visible.sync='dialogPasswordVisible' width='25%'>
      <el-form label-width='60px' :model='passwordData'>
        <el-form-item label='新密码'>
          <el-input t v-model='passwordData.password' placeholder='请输入新密码'></el-input>
        </el-form-item>
      </el-form>
      <div slot='footer' class='dialog-footer'>
        <el-button icon='el-icon-circle-close' @click='dialogPasswordVisible = false'>取 消</el-button>
        <el-button type='primary' icon='el-icon-circle-plus-outline' @click='handlePasswordClick'>确 定</el-button>
      </div>
    </el-dialog>


  </div>
</template>

<script>
import { gateway } from '@/api/admin.js'
import { getCookie } from '@/utils/auth'

export default {
  data() {
    return {
      id: '',

      tableParams: {
        id: null
      },
      loading: false,
      titleConfig: [
        {
          field: 'id',
          title: 'id',
          visible: false
        },
        // {
        //   field: 'agency_name',
        //   title: '所属代理商名称',
        //   visible: true
        // },
        {
          field: 'name',
          title: '用户姓名',
          visible: true
        },
        {
          field: 'login_name',
          title: '登录账号',
          visible: true
        },
        {
          field: 'phone',
          title: '手机号码',
          visible: true
        },
        {
          field: 'role_name',
          title: '用户角色',
          visible: true
        },
        {
          field: 'login_time',
          title: '最后登录时间',
          visible: true
        },
        {
          title: '操作',
          width: 80,
          align: 'right',
          option: true,
          children: [
            {
              title: '编辑',
              color: '#67C23A',
              icon: 'el-icon-edit-outline',
              fuc: this.showEdit
            },
            {
              title: '改密',
              color: '#E6A23C',
              icon: 'el-icon-key',
              fuc: this.handleSettingClick
            },
            {
              title: '删除',
              color: '#F56C6C',
              icon: 'el-icon-delete',
              fuc: row => {
                this.delete(row)
              }
            }
          ]
        }
      ],
      //编辑框信息
      editTip: '',
      editVisible: false,
      formLabelWidth: '230px',
      form: {
        id: 0,
        login_name: '',
        agency_id: null,
        role_id: '',
        password: '',
        phone: '',
        name: ''
      },
      isEdit: false,
      role_options: [],
      rules: {
        login_name: [
          { required: true, message: '请输入登录账户', trigger: 'blur' },
          { max: 20, message: '输入的文字过长，长度应在 20 个字符内', trigger: 'blur' }
        ],
        password: [
          { required: true, message: '请输入登录密码', trigger: 'blur' },
          { max: 20, message: '输入的文字过长，长度应在 20 个字符内', trigger: 'blur' }
        ],
        name: [
          { required: true, message: '请输入用户姓名', trigger: 'blur' },
          { max: 20, message: '输入的文字过长，长度应在 20 个字符内', trigger: 'blur' }
        ],
        phone: [
          { required: true, message: '请输入手机号码', trigger: 'blur' },
          { max: 11, message: '输入的文字过长，长度应在 11 个字符内', trigger: 'blur' }
        ],
        role_id: [
          { required: true, message: '请输入用户角色', trigger: 'change' }
        ]
      },
      //编辑框信息（密码）
      dialogPasswordVisible: false,
      passwordData: {
        login_name: '',
        password: ''
      }
    }
  },
  computed: {
    requestFun() {
      return gateway
    }
  },
  created() {
    this.id = this.$route.query.id
    this.tableParams.carpark_id = this.$route.query.carpark_id
    this.getRole()
  },
  methods: {
    //关闭编辑对话框
    closeDialog() {
      this.isEdit = false
      this.editVisible = false
      this.form = {}
      this.$refs['form'].resetFields()
      this.$refs['form'].clearValidate()
    },

    //弹出编辑(新增)对话框
    showAdd() {

      this.isEdit = false
      this.editVisible = true
      this.editTip = '新增信息'

      this.form = Object.assign({ uid: this.form.id, agency_id: parseInt(getCookie('agency_id')) })
    },

    //弹出编辑(修改)对话框
    showEdit(row) {

      this.isEdit = true
      this.editVisible = true
      this.editTip = '编辑信息'

      this.form = Object.assign({}, row)
    },

    //删除某条计时收费标准记录
    delete(row) {
      this.$confirm('是否要删除：' + row.login_name + '？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let str = JSON.stringify({
          id: row.id
        })
        gateway({
          func: 'other_remove_agency_user',
          params: str
        }).then(() => {



          this.$refs.table.refresh()
        })
      }).catch(() => {

      })
    },

    // handleDeleteClick(row){
    //   console.log(row)
    //   this.$confirm('是否删除账户：'+row.login_name+" ？", '提示', {
    //     confirmButtonText: '确定',
    //     cancelButtonText: '取消',
    //     type: 'warning'
    //   }).then(() => {
    //
    //   }).catch(() => {
    //
    //   });
    // },

    //修改
    save() {
      this.$refs.form.validate(valid => {
        if (valid) {

          var params = {}
          if (this.isEdit) {
            params = {
              login_name: this.form.login_name,
              id: this.form.id,
              name: this.form.name,
              phone: this.form.phone,
              role_id: this.form.role_id
            }
          } else {
            params = this.form
          }

          gateway({
            func: this.isEdit == true ? 'set_agency_user' : 'create_agency_user',
            params: JSON.stringify(params)
          }).then(res => {
            if (res.code === 0) {
              if (this.isEdit) {
                this.$message.success('编辑信息成功')
              } else {
                this.$message.success('新增用户成功')
              }
              this.closeDialog()
              this.$refs.table.refresh()
            } else {
              this.$message.warning(res.msg)
            }
          })

        } else {
          return false
        }
      })

    },
    //查找按钮事件
    find() {
      this.tableParams.id = parseInt(this.id)
    },

    handleSettingClick(row) {
      this.dialogPasswordVisible = true
      this.passwordData.login_name = row.login_name
      this.passwordData.password = ''
    },

    handlePasswordClick: function() {
      if (this.passwordData.password == '') {
        this.$message.warning('请输入新密码')
        return
      }
      gateway({
        func: 'set_agency_password_other',
        params: JSON.stringify(this.passwordData)
      }).then(res => {
        if (res.code === 0) {
          this.dialogPasswordVisible = false
          this.$message.success('设置密码成功')
        } else {
          this.$message.warning(res.msg)
        }
      })
    },
    //获取角色信息
    getRole() {
      gateway({
        func: 'get_agency_role',
        params: JSON.stringify({
          role_id: 0
        })
      }).then(res => {
        this.role_options = res.result
      })
    }
  }
}
</script>

<style scoped>
.left-table {
  margin-right: 0.5rem;
  color: #8f9398;
  font-size: 18px;
  font-weight: 500;
  margin-left: 10px;
}
</style>
